import { useState, useEffect, useRef } from "react";
const testimonials = [{
  quote: '"Herr Pescariu und sein Team haben unsere Altbauwohnung komplett renoviert. Die Arbeit war sauber, pünktlich und der Preis absolut fair. Wir sind begeistert!"',
  name: "Familie Müller",
  location: "Bielefeld Mitte"
}, {
  quote: '"Schnelle und unkomplizierte Entrümpelung unseres Kellers. Kann ich nur weiterempfehlen."',
  name: "Thomas K.",
  location: "Hannover"
}, {
  quote: '"Neue Fliesen im Bad und Laminat in der ganzen Wohnung – alles perfekt. Vielen Dank an das IDP-Team!"',
  name: "Maria S.",
  location: "Lemgo"
}];
const QuoteIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{
  color: "#C8A96E"
}}>
    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path>
    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"></path>
  </svg>;
const StarIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#C8A96E" stroke="#C8A96E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
  </svg>;
export default function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={sectionRef} style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: 'Inter, "Inter Fallback"',
    paddingTop: "60px",
    paddingBottom: "60px",
    animation: "none 0s ease 0s 1 normal none running",
    backgroundColor: "#FFFFFF"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:wght@700&display=swap');`}</style>
      <div className="page-container">
        <div className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col items-center mb-12">
            <div style={{
            width: "32px",
            height: "1px",
            backgroundColor: "#C8A96E",
            marginBottom: "12px"
          }} />
            <p style={{
            color: "rgb(200, 169, 110)",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
            letterSpacing: "1.4px",
            border: "0px solid rgb(200, 169, 110)",
            textTransform: "uppercase",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "8px"
          }}>
              KUNDENSTIMMEN
            </p>
            <h2 style={{
            color: "rgb(26, 26, 26)",
            fontFamily: '"Playfair Display", "Playfair Display Fallback"',
            fontSize: "36px",
            fontWeight: "700",
            lineHeight: "40px",
            border: "0px solid rgb(26, 26, 26)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            margin: "0"
          }}>
              Das sagen unsere Kunden
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.map((t, i) => <div key={i} className="flex flex-col hover:shadow-xl transition-shadow duration-300" style={{
            backgroundColor: "#FFFFFF",
            border: "1px solid rgba(0,0,0,0.08)",
            borderRadius: "8px",
            boxShadow: "0px 2px 12px rgba(0,0,0,0.06)",
            padding: "22px 32px",
            transitionDelay: `${i * 100}ms`
          }}>
                <div style={{
              marginBottom: "16px"
            }}>
                  <QuoteIcon />
                </div>

                <p style={{
              color: "lab(35.6337 -1.58697 -10.8425)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "16px",
              fontWeight: "400",
              lineHeight: "26px",
              border: "0px solid lab(35.6337 -1.58697 -10.8425)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "16px",
              flex: "1"
            }}>
                  {t.quote}
                </p>

                <div className="flex flex-row gap-1" style={{
              marginBottom: "8px"
            }}>
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} />)}
                </div>

                <p style={{
              color: "rgb(26, 26, 26)",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px",
              border: "0px solid rgb(26, 26, 26)",
              animation: "none 0s ease 0s 1 normal none running",
              marginBottom: "2px"
            }}>
                  {t.name}
                </p>

                <p style={{
              color: "#6A7282",
              fontFamily: 'Inter, "Inter Fallback"',
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              margin: "0"
            }}>
                  {t.location}
                </p>
              </div>)}
          </div>

          <div className="flex justify-center" style={{
          marginTop: "40px"
        }}>
            <p style={{
            color: "#6A7282",
            fontFamily: 'Inter, "Inter Fallback"',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            textAlign: "center",
            margin: "0"
          }}>
              Basierend auf Kundenrückmeldungen
            </p>
          </div>
        </div>
      </div>
    </section>;
}